import { render, staticRenderFns } from "./swiper-detail.vue?vue&type=template&id=e8741908&scoped=true"
import script from "./swiper-detail.vue?vue&type=script&lang=js"
export * from "./swiper-detail.vue?vue&type=script&lang=js"
import style0 from "./swiper-detail.vue?vue&type=style&index=0&id=e8741908&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8741908",
  null
  
)

export default component.exports